import { SPACING } from "../../../constants/Spacing";
import { BORDER } from '../../../constants/Border';
import { SIZES } from '../../../constants/Sizes';

export const SX_STYLES = {
    btnStyle: {
        fontSize: SIZES._16px,
        textTransform:'none',
        paddingTop: SPACING._12px,
        paddingBottom: SPACING._12px,
        paddingRight: SPACING._20px,
        paddingLeft: SPACING._20px,
        borderRadius: BORDER._8px,
        transition: 'transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 20px rgba(41,97,231,0.18)',
        },
        '&:active': {
            transform: 'translateY(0px)',
        },
    },
}